import Context from './index';
import React, { useState } from 'react';
import request from 'Utils/Helper/Request';

const UserProvider = (props) => {
    const [users, setUsers] = useState([]);
    const [user, setUser] = useState({});
 
    /** Fetch Users */
    const adminFetchUsers = async () => {
        try {
            const response = await request(`${process.env.REACT_APP_MTN_BASE_API_URL}/admin/user`,{ 
                method: 'GET', 
                authType: 'accessToken' 
            });
            setUsers(response.data);
        } catch (error) {
            throw error; 
        }
    };

    /** Fetch Cryptocurrencies */
    const adminFetchUser = async (user_id) => {
        try {
            const response = await request(`${process.env.REACT_APP_MTN_BASE_API_URL}/admin/user/${user_id}`,{ 
                method: 'GET', 
                authType: 'accessToken' 
            });
            setUser(response.data);
        } catch (error) {
            throw error; 
        }
    };

    return (
        <Context.Provider
            value={{
                ...props,
                users,
                user,
                setUser,
                adminFetchUsers,
                adminFetchUser
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default UserProvider;